export default {"src":"/_next/static/media/bg-shape-green.ed5bc2b1.svg","height":193,"width":1377,"blurWidth":0,"blurHeight":0};